"use client";

import PropTypes from "prop-types";
import React, { Component } from "react";

const scrollStyle = (width, height = "3px", color = "#F43059", duration = "1") => ({
    margin: 0,
    padding: 0,
    position: "fixed",
    top: 0,
    zIndex: "99",
    backgroundColor: `${color}`,
    height: `${height}px`,
    width: `${width}`,
    transitionProperty: "width",
    transitionDuration: `${duration}s`,
    transitionTimingFunction: `ease-out`,
});

class ProgressBar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            width: null,
        };
        this.Scrolling = this.Scrolling.bind(this);
    }

    Scrolling() {
        const winScroll = document.body.scrollTop || document.documentElement.scrollTop;
        const height =
            document.documentElement.scrollHeight - document.documentElement.clientHeight;
        const scrolled = (winScroll / height) * 150;
        if (height > 0) {
            this.setState({ width: `${scrolled}%` });
        } else {
            this.setState({ width: null });
        }
    }

    componentDidMount() {
        try {
            window.addEventListener("scroll", this.Scrolling);
        } catch (oError) {
            console.err(oError);
        }
    }

    componentWillUnmount() {
        try {
            window.removeEventListener("scroll", this.Scrolling);
        } catch (oError) {
            console.err(oError);
        }
    }

    render() {
        const { width } = this.state;
        const { height, color, duration } = this.props;
        return <div style={scrollStyle(width, height, color, duration)} />;
    }
}

ProgressBar.propTypes = {
    height: PropTypes.number,
    duration: PropTypes.number,
    color: PropTypes.string.isRequired,
};

export default ProgressBar;
